(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-comunidad"] && !Shopify.designMode) return;
  try {
    
  class VfComunidad extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-vf-track]');
      this.querySelectorAll('[data-vf-dir]').forEach((btn) => {
        btn.addEventListener('click', () => this.scrollByCard(parseInt(btn.dataset.vfDir, 10)));
      });
      this.querySelectorAll('[data-vf-embed]').forEach((btn) => {
        btn.addEventListener('click', () => this.loadEmbed(btn));
      });
    }

    scrollByCard(dir) {
      if (!this.track) return;
      const card = this.track.querySelector('.vf-com__card');
      const step = card ? card.getBoundingClientRect().width + 22 : this.track.clientWidth * 0.8;
      this.track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }

    loadEmbed(btn) {
      const tpl = btn.querySelector('template');
      if (!tpl) return;
      const frag = tpl.content.cloneNode(true);
      btn.replaceWith(frag.firstElementChild || frag);
    }
  }

  if (!customElements.get('vf-comunidad')) {
    customElements.define('vf-comunidad', VfComunidad);
  }

  document.querySelectorAll('.vf-com').forEach((el) => {
    if (el.tagName.toLowerCase() !== 'vf-comunidad' && !el.__vfInit) {
      el.__vfInit = true;
      const track = el.querySelector('[data-vf-track]');
      el.querySelectorAll('[data-vf-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          if (!track) return;
          const card = track.querySelector('.vf-com__card');
          const step = card ? card.getBoundingClientRect().width + 22 : track.clientWidth * 0.8;
          track.scrollBy({ left: step * parseInt(btn.dataset.vfDir, 10), behavior: 'smooth' });
        });
      });
      el.querySelectorAll('[data-vf-embed]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const tpl = btn.querySelector('template');
          if (!tpl) return;
          const frag = tpl.content.cloneNode(true);
          btn.replaceWith(frag.firstElementChild || frag);
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-timeline"] && !Shopify.designMode) return;
  try {
    
  class VfTimeline extends HTMLElement {
    connectedCallback() {
      this.nodes = Array.from(this.querySelectorAll('.vf-tl-node'));
      this.panels = Array.from(this.querySelectorAll('.vf-tl-panel'));
      this.fill = this.querySelector('.vf-tl-line-fill');
      this.count = this.nodes.length;
      this.autoplay = this.getAttribute('data-autoplay') === 'true';
      this.speed = parseInt(this.getAttribute('data-speed'), 10) || 1100;
      this.timers = [];
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.count === 0) return;

      this.nodes.forEach((node, i) => {
        node.addEventListener('click', () => {
          this.stopAuto();
          this.setActive(i);
        });
      });

      this.setActive(0);

      if (this.autoplay && !this.reduced && this.count > 1) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.observer.disconnect();
              this.play();
            }
          });
        }, { threshold: 0.4 });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      this.stopAuto();
      if (this.observer) this.observer.disconnect();
    }

    setActive(index) {
      this.nodes.forEach((node, i) => {
        node.classList.toggle('is-active', i === index);
        node.classList.toggle('is-reached', i < index);
        node.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
      const pct = this.count > 1 ? (index / (this.count - 1)) * 100 : 0;
      if (this.fill) this.fill.style.setProperty('--vf-fill', pct + '%');
    }

    play() {
      let i = 0;
      this.setActive(0);
      const step = () => {
        i += 1;
        if (i < this.count) {
          this.setActive(i);
          this.timers.push(setTimeout(step, this.speed));
        }
      };
      this.timers.push(setTimeout(step, this.speed));
    }

    stopAuto() {
      this.timers.forEach((t) => clearTimeout(t));
      this.timers = [];
    }
  }

  if (!customElements.get('vf-timeline')) {
    customElements.define('vf-timeline', VfTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vf-urgencia"] && !Shopify.designMode) return;
  try {
    
  class VfUrgencia extends HTMLElement {
    connectedCallback() {
      this.cd = this.querySelector('.vf-urg__countdown');
      if (this.cd) this.initCountdown();
      this.notes = Array.from(this.querySelectorAll('[data-note]'));
      if (this.notes.length > 1) this.initRotation();
    }

    pad(n) { return String(n).padStart(2, '0'); }

    initCountdown() {
      const raw = (this.cd.getAttribute('data-end') || '').trim().replace(' ', 'T');
      this.end = raw ? new Date(raw).getTime() : NaN;
      this.boxesEl = this.cd.querySelector('.vf-urg__cd-boxes');
      this.expiredEl = this.cd.querySelector('.vf-urg__expired');
      this.daysWrap = this.cd.querySelector('[data-days-wrap]');
      this.elDays = this.cd.querySelector('[data-days]');
      this.elHours = this.cd.querySelector('[data-hours]');
      this.elMins = this.cd.querySelector('[data-mins]');
      this.elSecs = this.cd.querySelector('[data-secs]');
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    tick() {
      if (isNaN(this.end)) return;
      const diff = this.end - Date.now();
      if (diff <= 0) {
        clearInterval(this.timer);
        if (this.boxesEl) this.boxesEl.hidden = true;
        if (this.expiredEl) this.expiredEl.hidden = false;
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      if (this.daysWrap) this.daysWrap.hidden = d <= 0;
      if (this.elDays) this.elDays.textContent = this.pad(d);
      this.elHours.textContent = this.pad(h);
      this.elMins.textContent = this.pad(m);
      this.elSecs.textContent = this.pad(s);
    }

    initRotation() {
      const speed = parseInt(this.getAttribute('data-rotate'), 10) || 4000;
      let i = 0;
      this.rot = setInterval(() => {
        this.notes[i].classList.remove('is-active');
        i = (i + 1) % this.notes.length;
        this.notes[i].classList.add('is-active');
      }, speed);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      clearInterval(this.rot);
    }
  }

  if (!customElements.get('vf-urgencia')) {
    customElements.define('vf-urgencia', VfUrgencia);
  }

  } catch(e) { console.error(e); }
})();
})();
